// import "./Home.css";
// import { FiArrowRight, FiGrid } from "react-icons/fi";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay } from "swiper/modules";
// import "swiper/css";
// import { Link } from "react-router-dom";
// import { useHiddenCategories } from "../../api/hiddenCategories";
// const categories = [
//   {
//     id: 1,
//     title: "Rudrakshas",
//     mainCategory: "rudrakshas",
//     subCategory: "rudrakshas",
//     image:
//       "https://res.cloudinary.com/dbb2hkjri/image/upload/v1793008317/file_00000000d1b8820aadc659376d854135_ae5u01.png",
//   },
//   {
//     id: 2,
//     title: "Shivling",
//     mainCategory: "shivling",
//     subCategory: "Shivling",
//     image:
//       "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792819052/file_00000000b8f0820abdd8c9f4a91a11b1_fdknyh.png",
//   },
//   {
//     id: 3,
//     title: "Shankh & Sea Shells",
//     mainCategory: "shankh-sea-shells",
//     subCategory: "dakshinavarti-shankh",
//     image:
//       "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792819052/file_00000000f7b481f489dd24f231401967_er5k9d.png",
//   },
//   {
//     id: 3,
//     title: "Shaligram",
//     mainCategory: "shaligram",
//     subCategory: "shaligram",
//     image:
//       "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792819053/file_00000000ce5882119c88c3b84f017345_r9tl9s.png",
//   },
//   {
//     id: 3,
//     title: "Gemstones",
//     mainCategory: "gemstones",
//     subCategory: "precious-gemstones",
//     image:
//       "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792819052/file_000000008e20820a817b81719ad0fcdb_yxwxrg.png",
//   },
//   {
//     id: 3,
//     title: "Crystals & Healing Stones",
//     mainCategory: "crystals",
//     subCategory: "raw-stones",
//     image:
//       "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792819052/file_00000000aec481f48d3a5b50b313cb4b_zksmqo.png",
//   },
//   {
//     id: 5,
//     title: "Vastu",
//     mainCategory: "vastu-products",
//     subCategory: "pyramids",
//     image:
//       "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792819052/file_00000000027881f4973e7d1c76420d49_w0ag61.png",
//   },
//   {
//     id: 7,
//     title: "Pooja Essentials",
//     mainCategory: "pooja",
//     subCategory: "incense",
//     image:
//       "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792819053/file_000000000b74820a933ba9802cd563a1_pqacpp.png",
//   },
//   {
//     id: 6,
//     title: "Perfumes",
//     mainCategory: "perfumes",
//     subCategory: "Perfumes",
//     image:
//       "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792819053/file_000000009374820a865fba6dedb257aa_izvkl3.png",
//   },
//   {
//     id: 7,
//     title: "Tulsi",
//     mainCategory: "tulsi",
//     subCategory: "tulsi",
//     image:
//       "https://res.cloudinary.com/dbb2hkjri/image/upload/v1793013735/ffb8f0c3-e43d-4dfe-af64-67944f5b6cc3_xuvbni.png",
//   },
// ];

// export default function CategorySection() {
//   const { isCategoryHidden } = useHiddenCategories();
//   return (
//     <section className="category-section">
//       <div className="containera">
//         <div className="heading-wrapper">
//           <h1>
//             New
//             <span> Arrivals</span>
//             <div className="about-heading-line">
//               <img
//                 src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
//                 alt="Heading decoration"
//               />
//             </div>
//           </h1>
//         </div>
//         <p>
//           We always try to provide you best-in-class, and authentic spiritual
//           products to bring positivity & balance in your life.
//         </p>
//         <div className="category-grida">
//           <div className="category-slider">
//             <Swiper
//               modules={[Autoplay]}
//               slidesPerView={4}
//               spaceBetween={20}
//               loop={true}
//               speed={1200}
//               autoplay={{
//                 delay: 2500,
//                 disableOnInteraction: false,
//               }}
//               breakpoints={{
//                 0: {
//                   slidesPerView: 1,
//                 },
//                 576: {
//                   slidesPerView: 2,
//                 },
//                 992: {
//                   slidesPerView: 4,
//                 },
//               }}
//             >
//               {categories
//                 .filter(
//                   (item) => !isCategoryHidden(item.mainCategory, item.title),
//                 )
//                 .map((item) => (
//                   <SwiperSlide key={item.id}>
//                     <div className="category-carda">
//                       <img src={item.image} alt={item.title} />

//                       <div className="overlay"></div>

//                       <div className="content">
//                         <h3>{item.title}</h3>

//                         <Link
//                           to={`/shop/${item.mainCategory}`}
//                           className="explore-btn"
//                         >
//                           Explore <FiArrowRight />
//                         </Link>
//                       </div>
//                     </div>
//                   </SwiperSlide>
//                 ))}
//             </Swiper>
//           </div>

//           <div className="calculator-card">
//             <div className="icon">
//               <FiGrid />
//             </div>

//             <h3>Need Help?</h3>

//             <p>Contact our experts for personalized guidance and support.</p>

//             <Link to="/contact" className="contact-btn">
//               Contact Us
//               <FiArrowRight />
//             </Link>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }



import React, { useEffect, useState } from "react";
import "./Home.css";
import { FiArrowRight, FiGrid } from "react-icons/fi";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { Link } from "react-router-dom";
import { useHiddenCategories } from "../../api/hiddenCategories";
const API_BASE_URL =
  "https://astrologicalsolutions.astrologicalsolutions.in";

const getImageUrl = (image) => {
  if (!image || typeof image !== "string") return "";

  const imagePath = image.trim();

  if (!imagePath) return "";

  if (/^https?:\/\//i.test(imagePath)) {
    return imagePath;
  }

  if (imagePath.startsWith("//")) {
    return `${window.location.protocol}${imagePath}`;
  }

  if (
    imagePath.startsWith("data:") ||
    imagePath.startsWith("blob:")
  ) {
    return imagePath;
  }

  return `${API_BASE_URL}/${imagePath.replace(/^\/+/, "")}`;
};

const getProductImage = (product) => {
  const images = Array.isArray(product.images)
    ? product.images
    : [];

  const primaryImage = images.find(
    (img) => img.isPrimary === true
  );

  const selectedImage =
    primaryImage?.imageUrl ||
    images[0]?.imageUrl ||
    images[0]?.thumbUrl ||
    "";

  return getImageUrl(selectedImage);
};

// ======================================
// CATEGORY SECTION
// ======================================
export default function CategorySection() {
  const { isCategoryHidden } = useHiddenCategories();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // ======================================
  // FETCH LATEST PRODUCTS
  // ======================================
  useEffect(() => {
    const controller = new AbortController();

    const fetchNewArrivals = async () => {
      try {
        setLoading(true);
        setError("");

        const apiUrl =
          `${API_BASE_URL}/api/v1/products?status=active&page=1&limit=50`;

        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error(
            `Products API failed: ${response.status}`
          );
        }

        const result = await response.json();

        console.log("Products API Response:", result);

        const productList =
          result?.data?.products || [];

        if (!Array.isArray(productList)) {
          throw new Error("Products array not found.");
        }

        // Only active products
        const activeProducts = productList.filter(
          (product) =>
            String(product.status).toLowerCase() === "active"
        );

        // Latest products first using createdAt
        activeProducts.sort((a, b) => {
          const dateA = new Date(a.createdAt).getTime();
          const dateB = new Date(b.createdAt).getTime();

          return dateB - dateA;
        });

        // Show latest 8 products only
        setProducts(activeProducts.slice(0, 8));

        console.log(
          "Latest 8 New Arrivals:",
          activeProducts.slice(0, 8)
        );

      } catch (err) {
        if (err.name === "AbortError") return;

        console.error("New Arrivals Error:", err);

        setError(
          err.message ||
          "Products load nahi ho paaye. Please try again."
        );
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    fetchNewArrivals();

    return () => controller.abort();
  }, []);

  // ======================================
  // FILTER HIDDEN CATEGORIES
  // ======================================
  const visibleProducts = products.filter((product) => {
    const category = product.category?.slug || "";
    const categoryName = product.category?.name || "";

    return !isCategoryHidden(category, categoryName);
  });

  // ======================================
  // RENDER
  // ======================================
  return (
    <section className="category-section">
      <div className="containera">

        {/* Heading */}
        <div className="heading-wrapper">
          <h1>
            New <span>Arrivals</span>

            <div className="about-heading-line">
              <img
                src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
                alt="Heading decoration"
              />
            </div>
          </h1>
        </div>

        <p>
          We always try to provide you best-in-class, and authentic
          spiritual products to bring positivity &amp; balance in your life.
        </p>

        <div className="category-grida">

          {/* New Arrivals Slider */}
          <div className="category-slider">

            {loading ? (
              <div className="new-arrivals-message">
                Loading new arrivals...
              </div>
            ) : error ? (
              <div className="new-arrivals-message">
                {error}
              </div>
            ) : visibleProducts.length === 0 ? (
              <div className="new-arrivals-message">
                No new products available right now.
              </div>
            ) : (
              <Swiper
                modules={[Autoplay]}
                slidesPerView={4}
                spaceBetween={20}
                loop={visibleProducts.length > 4}
                speed={1200}
                autoplay={
                  visibleProducts.length > 1
                    ? {
                        delay: 2500,
                        disableOnInteraction: false,
                      }
                    : false
                }
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  576: {
                    slidesPerView: 2,
                  },
                  992: {
                    slidesPerView: 4,
                  },
                }}
              >
                {visibleProducts.map((product) => {
                  const productId = product.id;
                  const productName =
                    product.name || "Spiritual Product";

                  const imageUrl = getProductImage(product);

                  return (
                    <SwiperSlide key={productId}>
                      <div className="category-carda">

                        {imageUrl ? (
                          <img
                            src={imageUrl}
                            alt={productName}
                            loading="lazy"
                            onError={(event) => {
                              console.error(
                                "Product image failed:",
                                imageUrl
                              );
                              event.currentTarget.style.display = "none";
                            }}
                          />
                        ) : (
                          <div className="new-arrivals-no-image">
                            No Image Available
                          </div>
                        )}

                        <div className="overlay"></div>

                        <div className="content">
                          <h3>{productName}</h3>

                          <Link
                            to={`/product/${productId}`}
                            className="explore-btn"
                          >
                            View Product <FiArrowRight />
                          </Link>
                        </div>

                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            )}

          </div>

          {/* Need Help Card */}
          <div className="calculator-card">
            <div className="icon">
              <FiGrid />
            </div>

            <h3>Need Help?</h3>

            <p>
              Contact our experts for personalized guidance
              and support.
            </p>

            <Link to="/contact" className="contact-btn">
              Contact Us <FiArrowRight />
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
}
